import React, { lazy } from 'react'
import ComponentLoader from './component-loader'

const RegisterPassFormGrothtool = ComponentLoader(
  lazy(() => import('screens/public/register-new-pass-growthtool'))
)
const RegisterPassFormCampaign = ComponentLoader(
  lazy(() => import('screens/public/register-new-pass'))
)

const Pass = ComponentLoader(lazy(() => import('screens/public/Pass')))
const PricingPlans = ComponentLoader(
  lazy(() => import('screens/public/pricingplans'))
)

const PassGrowthTool = ComponentLoader(
  lazy(() => import('screens/public/Pass-growthtool'))
)

// NEWSFEED
const NewsFeed = ComponentLoader(lazy(() => import('screens/public/newsfeed')))

const PublicRoutes = [
  {
    path: 'registration',
    children: [
      {
        path: 'tool/:growthtool_code',
        element: <RegisterPassFormGrothtool />,
      },
      {
        path: 'citypass/:growthtool_code/:campaign_code',
        element: <RegisterPassFormCampaign />,
      },
      {
        path: 'tool/:growthtool_code/:campaign_code',
        element: <RegisterPassFormCampaign />,
      },
    ],
  },
  {
    path: 'customer/pass/:pass_code',
    element: <Pass />,
  },
  {
    path: 'tool/:growthtool_code/user/:user_code',
    element: <PassGrowthTool />,
  },
  {
    path: 'public/newsfeed',
    element: <NewsFeed />,
  },
  {
    path: 'payment/plans',
    element: <PricingPlans />,
  },
]

export default PublicRoutes
